<template>
  <Component
    :is="component"
    v-if="isProxyMode || isGlobalProxyMode"
    :bundle="bundle"
    :uuid="uuid"
    :field-list-type="fieldListType"
    :parent-type="parentType"
    :item-props="props"
  />
  <Component
    :is="component"
    v-else-if="component"
    v-bind="props"
    :data-bk-in-proxy="fieldUsesProxy || void 0"
  />
  <div v-else-if="isEditing">Block not implemented</div>
</template>

<script setup>
import {
  computed,
  provide,
  useRuntimeConfig,
  inject,
  defineAsyncComponent,
  getCurrentInstance,
  onMounted
} from "#imports";
import { getComponent } from "#blokkli/helpers/imports";
import {
  INJECT_BLOCK_ITEM,
  INJECT_ENTITY_CONTEXT,
  INJECT_FIELD_LIST_TYPE,
  INJECT_FIELD_PROXY_MODE,
  INJECT_FIELD_USES_PROXY,
  INJECT_GLOBAL_PROXY_MODE
} from "../helpers/symbols";
const itemEntityType = useRuntimeConfig().public.blokkli.itemEntityType;
const componentProps = defineProps({
  uuid: { type: String, required: true },
  bundle: { type: String, required: true },
  isNew: { type: Boolean, required: false },
  options: { type: null, required: false, default: () => ({}) },
  props: { type: null, required: false, default: () => ({}) },
  index: { type: Number, required: false, default: 0 },
  parentType: { type: String, required: false, default: "" },
  isEditing: { type: Boolean, required: false, default: false }
});
const instance = componentProps.isEditing ? getCurrentInstance() : null;
const isProxyMode = inject(INJECT_FIELD_PROXY_MODE, false);
const fieldUsesProxy = inject(INJECT_FIELD_USES_PROXY, false);
const isGlobalProxyMode = inject(
  INJECT_GLOBAL_PROXY_MODE,
  null
);
const fieldListType = inject(
  INJECT_FIELD_LIST_TYPE,
  void 0
);
const component = isProxyMode || isGlobalProxyMode?.value ? defineAsyncComponent(() => import("./Edit/BlockProxy/index.vue")) : getComponent(
  "block",
  componentProps.bundle,
  fieldListType?.value || "default",
  componentProps.parentType
);
const index = computed(() => componentProps.index);
const item = computed(() => ({
  index,
  uuid: componentProps.uuid || "",
  options: componentProps.options || {},
  isEditing: componentProps.isEditing,
  parentType: componentProps.parentType,
  fragmentName: componentProps.bundle === "blokkli_fragment" ? componentProps.props?.name : void 0
}));
provide(INJECT_BLOCK_ITEM, item);
provide(INJECT_ENTITY_CONTEXT, {
  uuid: componentProps.uuid,
  type: itemEntityType,
  bundle: componentProps.bundle
});
</script>

<script>
export default {
  name: "BlokkliItem"
};
</script>
